import React from 'react';
import { StarPicker } from 'react-star-picker';
import { WebsiteImage } from 'components/TitleDescription';

import { Container } from './styles';

const SimpleContentfulTextBasedSocialProof = ({
  companyLogos,
  starColor,
  starOffColor,
  stars,
  title,
  theme,
}) => {
  return (
    <Container theme={theme}>
      <div className="section-demo-hero--rate-content">
        <StarPicker
          name="rating1"
          className="section-demo-hero--rate-star"
          value={stars}
          halfStars
          disabled
          size={40}
          starRendererProps={{
            colorActive: starColor,
            colorInactive: starOffColor,
          }}
        />
        <p className="section-demo-hero--rate-description">{title}</p>
      </div>

      <div className="section-demo-hero--rate-logo-content">
        {companyLogos.map((item, index) => {
          return (
            <div className="section-demo-hero--rate-logo-item" key={index}>
              <WebsiteImage src={item} />
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default SimpleContentfulTextBasedSocialProof;
